import React from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/Faqs/SectionContent/Search/Button/Button.module.scss';

const cn = classNames.bind(styles);

interface IButton {
    name: string;
    children: any;
    action?: (event: React.MouseEvent) => void;
    buttonStyles?: any;
}

const Button = ({ name, children, action, buttonStyles }: IButton) => {
    return (
        <div className={cn('button')}>
            <button
                className={cn('button__input')}
                name={name}
                type="button"
                onClick={action}
                style={buttonStyles ? buttonStyles : {}}
            >
                {children}
            </button>
        </div>
    );
};

export { Button };
